import { render, staticRenderFns } from "./BackCover.vue?vue&type=template&id=7564e0eb&scoped=true&"
import script from "./BackCover.vue?vue&type=script&lang=js&"
export * from "./BackCover.vue?vue&type=script&lang=js&"
import style0 from "./BackCover.vue?vue&type=style&index=0&id=7564e0eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7564e0eb",
  null
  
)

export default component.exports